import { createPortal } from "react-dom";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { HiX } from "react-icons/hi";

import { ClipSettingsBody } from "./ClipSettingsBody";

interface ClipSettingsModalProps {
  onClose: () => void;
}

export const ClipSettingsModal = ({ onClose }: ClipSettingsModalProps) => {
  return createPortal(
    <Overlay onClick={onClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>
          <HiX size={18} />
        </CloseButton>
        <ClipSettingsBody showHeader onNavigateAway={onClose} />
      </Modal>
    </Overlay>,
    document.getElementById("root") || document.body,
  );
};

const Overlay = styled(Flex)`
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  bottom: 0;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 101;
`;

const Modal = styled(Flex)`
  background: ${({ theme }) => theme.colors.ned};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  flex-direction: column;
  max-height: 90vh;
  max-width: 720px;
  overflow-y: auto;
  padding: 28px;
  position: relative;
  width: 90vw;
`;

const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.chalk};
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 4px;
  position: absolute;
  right: 16px;
  top: 16px;

  &:hover {
    background: ${({ theme }) => theme.colors.chalkAlpha20};
    color: ${({ theme }) => theme.colors.ice};
  }
`;
